//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {Tabs, Tab} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../../../assets/styles/colors';

type Props = {|
  value: number,
  onChange?: (event: SyntheticEvent<{}>) => void,
  labels: string[],
  className?: string,
|};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    backgroundColor: colors.grey300,
    borderRadius: '40px',
    padding: '4px ',
    width: '100%',
    margin: '3px',
  },
  customTab: {
    textTransform: 'none',
    minWidth: 72,
    minHeight: '20px',
    margin: '4px ',
    padding: '4px 2rem',
    fontWeight: 500,
    width: 'min-content',
    flex: 1,
    whiteSpace: 'nowrap',
  },
  activeTab: {
    color: colors.purple3,
    backgroundColor: 'white',
    borderRadius: '124px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16)',
  },
  indicator: {
    backgroundColor: 'transparent',
  },
  rootTabs: {
    [theme.breakpoints.down('sm')]: {
      margin: 'auto',
    },
  },
}));

export default function Switch(props: Props) {
  const {value, onChange, labels, className} = props;
  const classes = useStyles();

  return (
    <Tabs
      value={value}
      onChange={onChange}
      classes={{
        root: classes.rootTabs,
        indicator: classes.indicator,
        flexContainer: classes.flexContainer,
      }}
      textColor="primary"
      className={`${classes.tabs} ${className ?? ''}`}
      variant="scrollable"
    >
      {labels.map((label, index) => (
        <Tab
          fullWidth
          label={label}
          classes={{root: classes.customTab, selected: classes.activeTab}}
        />
      ))}
      {/* <Tab
        fullWidth
        label={labels[0]}
        classes={{root: classes.customTab, selected: classes.activeTab}}
      />
      <Tab
        fullWidth
        label={labels[1]}
        classes={{root: classes.customTab, selected: classes.activeTab}}
      /> */}
    </Tabs>
  );
}

Switch.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  labels: PropTypes.array,
};
